import type { ComponentProps } from 'react';
import { DialogFooter } from '../../components/ui/dialog';
import { cn } from '../../lib/utils';

export type BulkOperationDialogFooterProps = ComponentProps<
  typeof DialogFooter
>;

/** Shared footer spacing for each step of the bulk-operation dialog. */
export function BulkOperationDialogFooter({
  className,
  ...props
}: BulkOperationDialogFooterProps) {
  return (
    <DialogFooter {...props} className={cn('border-t px-6 py-4', className)} />
  );
}
